import type * as React from "react";
import { type FC, type ReactNode } from "react";
import { Link } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import ConfirmationModal from "~/common/components/ConfirmationModal";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useTranslation } from "react-i18next";

interface Props {
  showConfirmation?: boolean;
  label: ReactNode;
  popupMessage?: ReactNode;
  onReset: () => void;
  disabled?: boolean;
}

const LinearReset: FC<Props> = ({ showConfirmation, label, popupMessage, onReset, disabled }) => {
  const { t } = useTranslation();

  const { val: confirmationOpen, setTrue: openModal, setFalse: closeModal } = useBooleanState(false);

  const resetCb = showConfirmation
    ? (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        openModal();
      }
    : () => {
        onReset();
      };

  return (
    <>
      <Link href="#" onClick={resetCb} disabled={disabled}>
        <Icon type={IconType.Reload} className="icon-margin" />
        {label}
      </Link>
      {confirmationOpen && (
        <ConfirmationModal
          label={popupMessage}
          okLabel={t("generic.ok")}
          cancelLabel={t("common.no")}
          onOk={() => {
            closeModal();
            onReset();
          }}
          onCancel={closeModal}
        />
      )}
    </>
  );
};
export default LinearReset;
